import React, {useEffect} from 'react';
import axios from "axios";
import {SELFIE_STATE, useSelfieUploadState} from "../selfie_context";

export const Upload = () => {
  const {file, mode, setState, uploadFileIdentifier, pictureMode, overlayMediaFileId, setUploadedFile} = useSelfieUploadState()

  useEffect(() => {
    const formData = new FormData()
    formData.append("mode", mode)
    formData.append("file", file)
    formData.append("identifier", uploadFileIdentifier)
    formData.append("picture_mode", pictureMode)
    formData.append("overlay_media_file_id", overlayMediaFileId)

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    axios.post("/selfie_uploads", formData, config).then((response) => {
      setState(SELFIE_STATE.THANK_YOU)
      setUploadedFile(response.data.upload_file)
    }).catch((e) => {
      console.log(e)
      alert(e)
    })
  }, [])

  return <div className={"text-center p-3 selfie-upload-container"}>
    Uploading ...
  </div>
}